// extracted by mini-css-extract-plugin
export var slContainer = "bM_hj";
export var slLogoContainer = "bM_hk";
export var slText = "bM_hl";